<template>
  <div>

    <!-- :key="url" remounts the table when SettingsView swaps the category prop on the
         shared OrgTable instance (XolasTable does not refetch on a :url change). It also
         resets paging and the search text, as vuetable-2's apiUrl watcher did. -->
    <xolas-table
      :key="url"
      :title="title"
      :icon="'fa fa-' + getIcon(category)"
      title-heading="h2"

      table-ref="orgtable"

      :url="url"

      :fields="fields"

      :hide-top="!showTitle"
      :show-search="showSearch"
      sort-field="name"
      pipe-sort

      hide-org-badge

      layer-component="org"
      :layer-args="{ id: 'id' }">

      <template #actions>
        <org-action v-if="showAdd()" v-bind="addProps" />
      </template>

      <template #shortName="props">
        <org-badge :organisation="props.rowData" />
      </template>

      <template #subCat="props">
        <i>{{ellipsis(props.rowData.subCategory)}}</i>
      </template>

      <template #controls="props">
        <org-controls :row-data="props.rowData" table-ref="orgtable" />
      </template>

    </xolas-table>

  </div>
</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import FormattingMixins from '@/mixins/FormattingMixins'

import OrgAction from '@/components/actions/OrgAction'

import OrgControls from '@/components/tables/controls/OrgControls'

export default {
  mixins: [DateMixins, FormattingMixins],

  components: {
    OrgAction,
    OrgControls
  },

  props: {
    category: {
      type: String,
      default: null
    },

    title: {
      type: String,
      default: 'Organisations'
    },

    showTitle: {
      type: Boolean,
      default: true
    },

    showSearch: {
      type: Boolean,
      default: true
    }
  },



  methods: {

    showAdd () {
      return this.localCat && this.localCat === 'Xolas' ? false : true
    },

    getIcon (cat) {

      switch (cat) {

        case 'authority':
          return 'bank'

        case 'backhaul':
          return 'wifi'

        case 'contractor':
          return 'tools'

        case 'landlord':
          return 'house'

        case 'insurer':
          return 'shield-alt'

        case 'telco':
          return 'users'

        case 'tower supplier':
          return 'tower-cell'

        case 'utility':
          return 'plug'

        case 'xolas':
            return 'star'

        default:
          return 'table-columns'
      }

    }
  },



  watch: {

    category: function (value) {
      this.localCat = this.titleCase(value)
      this.addProps.category = this.localCat
    }

  },


  computed: {
    url: function () {
      return '/org' + (this.category ? '?filter=' + this.category : '')
    },

    isSubCategoryVisible: function () {

      if (this.localCat) {
        return this.localCat.includes('Contractor')
      }

    return false
    }

  },


  data () {
    return {
      addProps: {
        category: this.category ? this.category : '',
        isAdd: true
      },
      localCat: this.category,
      telcoId: this.isTelco() ? this.org().id : null,
      // XOL-235 A1 column widths, measured live on the pre-migration vuetable render of
      // #/settings/orgs-telco at 1504x1000 @1x (table width 1223px; the legacy table also
      // carried a 64px detail-toggle column and a 25px `#` column, now XolasTable's 70px
      // chevron and nothing). Every fixed column carries `width` = measured <th> px and a
      // `minWidth` floor of round(0.7 * measured) (XolasTable.md "Scaled-minWidth
      // convention"). `name` is the dominant flex column (minWidth only, 0.7 * 427).
      // `__slot:shortName` is flex too (minWidth only, 0.7 * 150): Name is hidden below
      // 992px, and something has to absorb the slack there. Their minWidth ratio (105:299)
      // reproduces the legacy 150:427 split at 1504px.
      fields: [
        {
          name: '__slot:shortName',
          title: 'Short Name',
          sortField: 'shortName',
          minWidth: '105'
        },
        {
          name: 'name',
          title: 'Name',
          sortField: 'name',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: '299'
        },
/*
        {
          name: 'Phone',
          sortField: 'phone',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
        },
        {
          name: 'email',
          sortField: 'email',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
        },
*/
        {
          title: '# Activities',
          name: 'active',
          width: '126',
          minWidth: '88'
        },
        {
          title: '# Contacts',
          name: 'contactsCount',
          width: '124',
          minWidth: '87'
        },
        {
          name: 'category',
          title: 'Category',
          sortField: 'category',
          width: '163',
          minWidth: '114'
        },
        {
          name: '__slot:subCat',
          title: 'Sub Cat.',
          titleClass: (this.isSubCategoryVisible ? 'hidden-lg-and-down' : 'hidden-md-and-down' ),
          dataClass: (this.isSubCategoryVisible ? 'hidden-lg-and-down' : 'hidden-md-and-down' ),
          width: '93',
          minWidth: '65'
        },
        {
          name: '__slot:controls',
          title: '',
          width: '52',
          minWidth: '36'
        }
      ]
    }
  },

  created () {
    if (this.category) {
      this.localCat = this.titleCase(this.category)
      this.addProps.category = this.localCat
    }
  }
}
</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
